import { POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES } from 'shared/mf-infrastructure/constants/transportAccessibilityInfrastructure';
import { EInsideTAInfrastructureType } from 'shared/mf-infrastructure/types/transportAccessibility';

export function isRouteForTypeAvailable(type: string) {
  return (
    !POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.includes((<string>type) as EInsideTAInfrastructureType) &&
    type !== 'futureRoad'
  );
}
